import AllPage from './AllPage.json';

// 计算套餐来源
export const computePlanSource = (type, source_type, planRes, planInfo, selData) => {
    const url = window.location.pathname;
    let discount = "";
    let paid_type = "";

    // 套餐ID
    const _id = planRes?.ppid || 1;

    // 获取套餐类型
    const getPlanType = (p_id) => {
        return ([2, 4].includes(p_id) ? 'monthly' : [8, 9].includes(p_id) ? 'annually' : '-');
    }

    // 获取套餐版本
    const getPlanVersion = (p_id) => {
        return [2, 4].includes(p_id) ? 'Pro Plan' : [8, 9].includes(p_id) ? 'Pre Plan' : 'Free';
    }

    // 获取折扣文案
    const getDiscountText = (data, type) => {
        const _t = data;
        const d_txt = _t?.rateText || '';
        const e_n = {
            1: "first",
            2: "second",
            3: "third",
            4: "fourth",
            5: "fifth",
            6: "sixth",
            7: "seventh",
            8: "eighth",
            9: "ninth",
            10: "tenth",
            11: "eleventh",
            12: "twelfth",
        }
        return d_txt.includes('OFF') ? `${d_txt}${_t?.period > 0 ? '_' + e_n[_t?.period] + '_' + type : ''}` :
            d_txt.includes('-$') ? `${d_txt.split('-')[1]}${_t?.period > 0 ? '_' + e_n[_t?.period] + '_' + type : ''}` : `${d_txt}`;
    }

    // 获取折扣信息
    if (['usage_limit', 'promotion'].includes(source_type) && type === 'guide_entry_exposure') {
        discount = `[Pro - ${getDiscountText(planInfo.pro, 'monthly')}]-[Pre - ${getDiscountText(planInfo.pre, 'monthly')}]`;
    } else {
        discount = getDiscountText(selData, getPlanType(selData?.id || 1));
    }

    // 获取付费类型
    if (source_type === 'free_trial') {
        paid_type = (planInfo.pre_year?.trial_days > 0 || planInfo.pre_month?.trial_days > 0 || planRes.trial_days > 0) ? 'trial' : 'paid';
    } else {
        paid_type = (planInfo.pro?.trial_days > 0 || planInfo.pre?.trial_days > 0 || planRes.trial_days > 0) ? 'trial' : 'paid';
    }

    return {
        source_type,
        source_position: (source_type === 'free_trial' && !url.includes('guide')) ? 'sidebar' : AllPage[url],
        plan_type: getPlanType(_id),
        plan_version: getPlanVersion(_id),
        upgrade_plan_type: ['free_trial'].includes(source_type) ? getPlanType(selData?.id || 1) : 'monthly',
        upgrade_plan_version: (['usage_limit', 'promotion'].includes(source_type) && type === 'guide_entry_exposure') ? 'Pro & Pre' : getPlanVersion(selData?.id || 1),
        discount,
        paid_type,
    }
}